<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          Date Wise Cash Dispense Report : {{ this.monthName }} {{ year }}
        </h1>
        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table
          datatable
          class="row-border hover tablelist"
          *ngIf="dispenseArrayList.length > 0"
        >
          <thead>
            <tr>
              <td>Date</td>
              <td>Supervisor Name</td>
              <td>Company Name</td>
              <td>Description</td>
              <td>Total Amount</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dispense of dispenseArrayList">
              <td>{{ dispense.date }}</td>
              <td>{{ dispense.supervisorName }}</td>
              <td>{{ dispense.companyName }}</td>
              <td
                matTooltip="{{
                  dispense.description.length > 30 ? dispense.description : ''
                }}"
              >
                {{
                  dispense.description.length > 30
                    ? dispense.description.slice(0, 30) + "..."
                    : dispense.description
                }}
              </td>
              <td>{{ dispense.amount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
